import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-066e84d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ncgr-section ncgr-section--grouped-background ncgr-section--short ncgr-pad-t-24" }
const _hoisted_2 = { class: "ncgr-container -size-m -is-gapless" }
const _hoisted_3 = { class: "ncgr-sequence ncgr-mar-b-24" }
const _hoisted_4 = { class: "ncgr-sequence__items" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "ncgr-sequence__item ncgr-sequence__item--active" }, " 入力 ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "ncgr-sequence__item" }, " 完了 ", -1))
const _hoisted_7 = {
  key: 0,
  class: "bottom-action-bar"
}
const _hoisted_8 = { class: "bottom-action-bar__next" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "_body" }
const _hoisted_11 = { class: "bottom-action-bar__back" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_body" }, " 戻る ", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "bottom-action-bar"
}
const _hoisted_15 = { class: "bottom-action-bar__next" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_body" }, " 予約内容を確認する ", -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "bottom-action-bar__back" }
const _hoisted_19 = ["href"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_body" }, " 戻る ", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { ref: "epsilonJs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SuzuriHeader = _resolveComponent("SuzuriHeader")!
  const _component_OrderConfirm = _resolveComponent("OrderConfirm")!
  const _component_OrderForm = _resolveComponent("OrderForm")!
  const _component_FlashMessage = _resolveComponent("FlashMessage")!
  const _directive_track = _resolveDirective("track")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_SuzuriHeader),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("form", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("ul", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("li", {
                class: _normalizeClass(["ncgr-sequence__item", { 'ncgr-sequence__item--active': _ctx.confirm }])
              }, " 確認 ", 2),
              _hoisted_6
            ])
          ]),
          (_ctx.campaign)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.confirm)
                  ? (_openBlock(), _createBlock(_component_OrderConfirm, {
                      key: 0,
                      campaign: _ctx.campaign,
                      selections: _ctx.selections,
                      shippingAddress: _ctx.shippingAddress,
                      payment: _ctx.payment,
                      useRegisteredCreditCard: _ctx.useRegisteredCreditCard
                    }, null, 8, ["campaign", "selections", "shippingAddress", "payment", "useRegisteredCreditCard"]))
                  : (_openBlock(), _createBlock(_component_OrderForm, {
                      key: 1,
                      campaign: _ctx.campaign,
                      selections: _ctx.selections,
                      shippingAddress: _ctx.shippingAddress,
                      payment: _ctx.payment,
                      isAddressRegistered: _ctx.useRegisteredAddress,
                      isCreditCardRegistered: _ctx.useRegisteredCreditCard,
                      registeredCreditCard: _ctx.registeredCreditCard,
                      "onChange:selections": _ctx.handleSelectionsChange,
                      "onInput:address": _ctx.handleAddressInput,
                      "onInput:payment": _ctx.handlePaymentInput,
                      onEditRegisteredCard: _ctx.handleEditRegisteredCard
                    }, null, 8, ["campaign", "selections", "shippingAddress", "payment", "isAddressRegistered", "isCreditCardRegistered", "registeredCreditCard", "onChange:selections", "onInput:address", "onInput:payment", "onEditRegisteredCard"]))
              ], 64))
            : _createCommentVNode("", true)
        ]),
        (_ctx.confirm)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _withDirectives((_openBlock(), _createElementBlock("button", {
                  disabled: _ctx.submitting,
                  class: "to-confirm ncgr-button -color-interactive",
                  type: "submit",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
                }, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.submitLabel), 1)
                ], 8, _hoisted_9)), [
                  [_directive_track, void 0, "orders_reserve"]
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("a", {
                  href: "#",
                  class: "ncgr-button -appearance-transparent",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.backToInput && _ctx.backToInput(...args)), ["prevent"]))
                }, _hoisted_13)
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _withDirectives((_openBlock(), _createElementBlock("button", {
                  class: "to-confirm ncgr-button -color-interactive",
                  type: "submit",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.proceedToConfirm && _ctx.proceedToConfirm(...args)), ["prevent"]))
                }, _hoisted_17)), [
                  [_directive_track, void 0, "orders_confirm"]
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("a", {
                  href: _ctx.campaignPageUrl,
                  class: "ncgr-button -appearance-transparent"
                }, _hoisted_21, 8, _hoisted_19)
              ])
            ]))
      ])
    ]),
    _createVNode(_component_FlashMessage),
    _createElementVNode("div", _hoisted_22, null, 512)
  ]))
}